export const gameNamePrefixes = [
    'Shadow', 'Eternal', 'Cyber', 'Dark', 'Light', 'Void', 'Crystal', 'Iron', 'Steel',
    'Golden', 'Mystic', 'Silent', 'Infinite', 'Brave', 'Wild', 'Forgotten', 'Ancient',
    'Crimson', 'Azure', 'Neon', 'Solar', 'Lunar', 'Stellar', 'Galactic', 'Arcane',
    'Divine', 'Chaos', 'Order', 'Prime', 'Final', 'Lost', 'Hidden', 'Rising', 'Fallen',
    'Super', 'Mega', 'Ultra', 'Pixel', 'Retro', 'Epic', 'Legendary', 'Mythic'
];

export const gameNameSuffixes = [
    'Quest', 'Legends', 'Chronicles', 'Saga', 'Tales', 'Adventures', 'Origins',
    'Odyssey', 'Destiny', 'Legacy', 'Prophecy', 'Rebellion', 'Uprising', 'Warriors',
    'Heroes', 'Champions', 'Guardians', 'Knights', 'Empires', 'Kingdoms', 'Lands',
    'Worlds', 'Realms', 'Dimensions', 'Frontier', 'Horizon', 'Voyage', 'Journey',
    'Battle', 'Warfare', 'Combat', 'Arena', 'Strike', 'Force', 'Squad', 'Ops',
    'Simulator', 'Tycoon', 'Manager', 'Builder', 'Crafter', 'Runner', 'Dasher',
    'Racer', 'Fighter', 'Brawler', 'Shooter', 'Sniper', 'Assassin', 'Hunter'
];

export const trGameNamePrefixes = [
    'Gölge', 'Sonsuz', 'Siber', 'Karanlık', 'Işık', 'Hiçlik', 'Kristal', 'Demir', 'Çelik',
    'Altın', 'Mistik', 'Sessiz', 'Sınırsız', 'Cesur', 'Vahşi', 'Unutulmuş', 'Kadim',
    'Kızıl', 'Mavi', 'Neon', 'Güneş', 'Ay', 'Yıldız', 'Galaktik', 'Gizemli',
    'İlahi', 'Kaos', 'Düzen', 'Birincil', 'Son', 'Kayıp', 'Gizli', 'Yükselen', 'Düşmüş',
    'Süper', 'Mega', 'Ultra', 'Piksel', 'Retro', 'Epik', 'Efsanevi', 'Mitik'
];

export const trGameNameSuffixes = [
    'Görev', 'Efsaneleri', 'Günlükleri', 'Destanı', 'Masalları', 'Maceraları', 'Kökenleri',
    'Yolculuğu', 'Kaderi', 'Mirası', 'Kehaneti', 'İsyanı', 'Ayaklanması', 'Savaşçıları',
    'Kahramanları', 'Şampiyonları', 'Muhafızları', 'Şövalyeleri', 'İmparatorluğu', 'Krallığı', 'Toprakları',
    'Dünyaları', 'Diyarları', 'Boyutları', 'Sınırı', 'Ufku', 'Seferi', 'Yolculuğu',
    'Savaşı', 'Harbi', 'Dövüşü', 'Arenası', 'Vuruşu', 'Gücü', 'Tim', 'Operasyonu',
    'Simülatörü', 'Patronu', 'Yöneticisi', 'İnşaatçısı', 'Zanaatkarı', 'Koşucusu', 'Atılımcısı',
    'Yarışçısı', 'Dövüşçüsü', 'Kavgacısı', 'Nişancısı', 'Keskin Nişancısı', 'Suikastçısı', 'Avcısı'
];

export const frGameNamePrefixes = [
    'Ombre', 'Éternel', 'Cyber', 'Sombre', 'Lumière', 'Vide', 'Cristal', 'Fer', 'Acier',
    'Doré', 'Mystique', 'Silencieux', 'Infini', 'Brave', 'Sauvage', 'Oublié', 'Ancien',
    'Carmes', 'Azur', 'Néon', 'Solaire', 'Lunaire', 'Stellaire', 'Galactique', 'Arcane',
    'Divin', 'Chaos', 'Ordre', 'Premier', 'Final', 'Perdu', 'Caché', 'Montant', 'Dechu',
    'Super', 'Méga', 'Ultra', 'Pixel', 'Rétro', 'Épique', 'Légendaire', 'Mythique'
];

export const frGameNameSuffixes = [
    'Quête', 'Légendes', 'Chroniques', 'Saga', 'Contes', 'Aventures', 'Origines',
    'Odyssée', 'Destinée', 'Héritage', 'Prophétie', 'Rébellion', 'Soulèvement', 'Guerriers',
    'Héros', 'Champions', 'Gardiens', 'Chevaliers', 'Empires', 'Royaumes', 'Terres',
    'Mondes', 'Royaumes', 'Dimensions', 'Frontière', 'Horizon', 'Voyage', 'Journée',
    'Bataille', 'Guerre', 'Combat', 'Arène', 'Frappe', 'Force', 'Escouade', 'Ops',
    'Simulateur', 'Magnat', 'Manager', 'Bâtisseur', 'Artisan', 'Coureur', 'Fonceur',
    'Coureur', 'Combattant', 'Bagarreur', 'Tireur', 'Sniper', 'Assassin', 'Chasseur'
];

export const gameGenres = [
    'RPG', 'FPS', 'Strategy', 'Adventure', 'Simulation', 'Puzzle', 'Racing', 'Sports',
    'Fighting', 'Platformer', 'Survival', 'Horror', 'MMO', 'MOBA', 'Battle Royale'
];
